// extracted by mini-css-extract-plugin
export var h2_semi_bold_serp = "D_bT";
export var serpCard = "D_bR";
export var serpLink = "D_bS";